module.exports = __webpack_public_path__ + "img/2019110806.0b9c2850.jpg";